import * as Sentry from "@sentry/react-router";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  });
}

export function setSentryUser(user: { id: string; email?: string } | null) {
  Sentry.setUser(user ? { id: user.id, email: user.email } : null);
}

export { Sentry };
